import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  hubFilter,
  setHubFilter,
  applyFilters,
  removeFilters,
  apidata,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="hubFilter">
            <Form.Label>Hubs</Form.Label>
            <Form.Control
              as="select"
              value={hubFilter || ""}
              onChange={(e) => setHubFilter(e.target.value)}
            >
              <option value="">All Hubs</option>
              {apidata &&
                Array.from(new Set(apidata.flatMap((item) => item.hub || [])))
                  .filter(Boolean)
                  .map((hubName, index) => (
                    <option key={index} value={hubName}>
                      {hubName}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="fromDate">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDate">
            <Form.Label>To Date</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
